export const assert = (condition: any, message?: string) => {
  if (!condition) {
    throw message || 'Assertion failed';
  }
};
